import { withInstall } from "@xplus/utils/with-install";
import space from "./src/space";
export const xSpace = withInstall(space);
export default xSpace;
export * from "./src/space";
export * from "./src/use-space";
